export class EditScreenGrid {
    constructor() {
    }

    draw(grid) {
        let gridTitle = "";
        if (!grid.title)
            gridTitle = "No Name";
        else
            gridTitle = grid.title.resourceId;

        let gridContainer = $(`<li class="k-state-active">
										${gridTitle}
										<div class="table-responsive">
											<table id=${grid.fieldId}>
											<thead>
													<tr>
													</tr>
												</thead>
												<tbody>
         										<tr>
         										</tr>
         										</tbody>
												</table>`);
        for (let i = 0; i < grid.columns.length; i++) {
            gridContainer.find("thead").find("tr").append(`<th>${grid.columns[i].id}</th>`);

        }
        for (let i = 0; i < grid.columns.length; i++) {
            gridContainer.find("tbody").find("tr").append(`<td>${i}</td>`);
        }
        gridContainer.find("table[id='" + grid.fieldId + "'] ").kendoGrid({
            sortable: true,
            editable: {confirmation: false},
            navigatable: true,
            reorderable: true,
            filterable: true,
            autoSync: true,
            autoBind: true,
            resizable: true,
            columnMenu: true,
            allowCopy: true,
        });
        return gridContainer;
    }
}